import { Component, inject, Input } from '@angular/core';
import { GroupedTpaCoverage } from '../../../../models/tpa-group.model';
import { CommonModule } from '@angular/common';
import { CardAction } from '../../../../../../shared/components/generic-card/models/card-config.interface';
import { TpaService } from '../../../../services/tpa.service';
import { ActionId } from '../../../../models/sob.enum';
import { CensusLinesGroupViewComponent } from '../../../../../../shared/components/census-lines-group-view/census-lines-group-view.component';

@Component({
  selector: 'app-tpa-group-view',
  standalone: true,
  imports: [CommonModule, CensusLinesGroupViewComponent],
  templateUrl: './tpa-group-view.component.html',
  styleUrl: './tpa-group-view.component.scss',
})
export class TpaGroupViewComponent {
  allExpanded = false;

  private tpaService = inject(TpaService);

  @Input() groupViewData!: GroupedTpaCoverage;

  onActionClick(cardAction: CardAction) {
    const actionId = cardAction.id;

    switch (actionId) {
      case ActionId.openSobDialog:
        this.tpaService.setSobOpenDialog(
          cardAction?.extraData?.planId,
          cardAction?.extraData?.showPdf,
        );
        break;
      case ActionId.openPolicyDialog:
        this.tpaService.setPolicyOpenDialog(cardAction?.extraData?.policyId);
        break;
    }
  }
}
